import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {filter, startWith, takeUntil} from 'rxjs/operators';

import {Destroyable} from '../../destroyable.component';
import {ReportDefinition, ReportsFormData} from '../../models/models.interfaces';
import {RolesService} from '../authentication/roles/roles.service';
import {ProfileType} from '../employees/contract/contract.interfaces';
import {Contract} from '../employees/employees.model';
import {isPresent} from '../utils/lang';

@Component({
  selector: 'gp-contract-employee-menu',
  templateUrl: './contract-employee-menu.component.html',
  styleUrls: ['./contract-employee-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractEmployeeMenuComponent extends Destroyable implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  // TODO (context: GP-22)
  // nb: this component is a dumb copy/paste from employee-menu
  // employee-menu should be refactored to handle what we display more easily,
  // Then we could use it in essComponent to display only certificates and delete this one.

  @Input() public contractId: number;
  @Input() public cliRegId: number;
  @Input() public readOnly: boolean;
  @Input() public contract: Contract = {};
  @Input() public profileType: ProfileType;

  public menuItems: any = {};

  public reportDefinitions: Array<ReportDefinition>;
  public selectedReportDefinition: ReportDefinition;
  public hiddenValuesForReportDefinition = new Map();
  public availableReportsType = ['CERTIFICATE'];
  public hasReportAccess: boolean = false;
  @ViewChildren('items')
  private menuItemsQueryList: QueryList<ElementRef>;

  private menuItemsElements: HTMLLIElement[] = [];
  public triggerSortByTranslationPipe = true;
  public hasVisibleChild = true;

  constructor(private cd: ChangeDetectorRef,
              private rolesService: RolesService,
              private translate: TranslateService) {
    super();
  }

  public ngOnInit(): void {
    this.translate.onLangChange
      .pipe(
        takeUntil(this.componentDestroyed$)
      )
      .subscribe(() => {
        this.triggerSortByTranslationPipe = !this.triggerSortByTranslationPipe;
      });

    if (this.rolesService.hasRole('ESS_MY_CERTIFICATES')) {
      this.hasReportAccess = true;
    }
  }

  public ngAfterViewInit() {
    this.menuItemsQueryList.changes.pipe
    (
      startWith(this.menuItemsQueryList),
      filter((value: QueryList<ElementRef>) => value && !!value.first),
      takeUntil(this.componentDestroyed$)
    )
      .subscribe((value: QueryList<ElementRef>) => {
        this.menuItemsElements = Array.from(value.first.nativeElement.children);
        this.hasVisibleChild = this.menuItemsElements.some(item => !item.classList.contains('hide'));
        this.cd.detectChanges();
      });
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public ngOnChanges() {
    this.menuItems = {};
    if (isPresent(this.cliRegId) && isPresent(this.contractId)) {
      this.getMenuItems();
    }
  }

  public getMenuItems() {
    this.menuItems = {};
    this.setReportDefinitionsAsMenuItems();
  }

  public selectReportDefinition(reportDefinition: ReportDefinition) {
    this.menuItems.opened = false;
    this.selectedReportDefinition = reportDefinition;
    this.hiddenValuesForReportDefinition.set('contractId', this.contractId);
  }

  public reportDefinitionsLoaded(reportsFormData: ReportsFormData) {
    this.reportDefinitions = reportsFormData.data;
    this.setReportDefinitionsAsMenuItems();
    if (!this.isDestroyed) {
      this.cd.detectChanges();
    }
  }

  private setReportDefinitionsAsMenuItems() {
    if (!this.reportDefinitions || !this.menuItems) {
      return;
    }
    this.menuItems.certificates = this.getReportDefinitionsAsMenuItemsByTypes('CERTIFICATE');
  }

  public getReportDefinitionsAsMenuItemsByTypes(...types: string[]) {
    if (!this.reportDefinitions) {
      return [];
    }
    let menuItems = [];
    for (const type of types) {
      menuItems = menuItems.concat(this.reportDefinitions
        .filter((reportDefinition: ReportDefinition) => reportDefinition.reportType === type));
    }
    return menuItems;
  }

  public reportDefinitionListener() {
    this.selectedReportDefinition = null;
  }
}
